<template>
  <v-tabs
    v-model="tab"
    light
    fixed-tabs
    background-color="accent"
    color="primary"
    @change="SET_ARTICLE_TAB"
  >
    <v-tabs-slider></v-tabs-slider>

    <v-tab :href="
    `#tab-1`">
      Tutti gli Articoli
    </v-tab>

    <v-tab :href="`#tab-2`">
      Scrivi Articolo
    </v-tab>

    <v-tab-item :value="`tab-1`">
      <article-list></article-list>
    </v-tab-item>

    <v-tab-item :value="`tab-2`">
      <article-create></article-create>
    </v-tab-item>
  </v-tabs>
</template>

<script>
  import ArticleList from './../components/articles/ArticleList'
  import ArticleCreate from './../components/articles/ArticleCreate'
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'Articoli',
    components: {
      ArticleList,
      ArticleCreate
    },
    data() {
      return {
        tab: 'tab-1'
      }
    },
    computed: {
      ...mapGetters([
        'articleTab'
      ])
    },
    methods: {
      ...mapMutations([
        'SET_ARTICLE_TAB'
      ])
    },
    watch: {
      articleTab(val) {
        this.tab = val
      }
    },
    beforeDestroy() {
      alert('yolo')
    }
  }
</script>